<template>
  <div class="recommendation" ref="mainContainer">
    <el-tabs v-model="activeName">
      <el-tab-pane label="店铺推荐" name="first">
        <ShopRecommend />
      </el-tab-pane>
      <el-tab-pane label="热销推荐" name="second">
        <HotSaleRecommend />
      </el-tab-pane>
      <el-tab-pane label="限时秒杀" name="third">
        <SaleKickedRecommend />
      </el-tab-pane>
      <el-tab-pane label="盖楼推荐" name="fourth">
        <FloorRecommend />
      </el-tab-pane>
      <el-tab-pane label="商品推荐" name="five">
        <GoodsRecommend />
      </el-tab-pane>
      <el-tab-pane label="诊所必备" name="six">
        <clinicsCategory />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ShopRecommend from "./shopRecommend/index";
import HotSaleRecommend from "./hotSaleRecommend/index";
import SaleKickedRecommend from "./saleKickedRecommend/index";
import FloorRecommend from "./floorRecommend/index";
import GoodsRecommend from "./goodsRecommend/index";
import clinicsCategory from "./clinicsCategory/index";
import { getToken } from "@/utils/auth";
import { getList } from "@/api/release";

export default {
  components: {
    ShopRecommend,
    HotSaleRecommend,
    SaleKickedRecommend,
    FloorRecommend,
    GoodsRecommend,
    clinicsCategory,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.recommendation {
  background-color: #fff;
  height: calc(100vh - 140px);
  padding: 0 12px;
}
</style>
